module.exports = function() {
  return new Worker(__webpack_public_path__ + "601cee532a591378addf.worker.js");
};